"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var tamaguiSafeArea_native_exports = {};
__export(tamaguiSafeArea_native_exports, {
  feedTamaguiSafeArea: () => feedTamaguiSafeArea
});
module.exports = __toCommonJS(tamaguiSafeArea_native_exports);
function feedTamaguiSafeArea(metrics, hooks) {
  var _g, ___tamagui_safe_area__, _state, _useSafeAreaInsets, _state1, _useSafeAreaFrame;
  var _g___tamagui_safe_area_subscriptions__;
  var g = globalThis;
  var state = (___tamagui_safe_area__ = (_g = g).__tamagui_safe_area__) !== null && ___tamagui_safe_area__ !== void 0 ? ___tamagui_safe_area__ : _g.__tamagui_safe_area__ = {
    didSetup: false,
    enabled: false,
    useSafeAreaInsets: null,
    useSafeAreaFrame: null,
    initialMetrics: null
  };
  var previous = state.initialMetrics;
  state.didSetup = true;
  state.enabled = true;
  (_useSafeAreaInsets = (_state = state).useSafeAreaInsets) !== null && _useSafeAreaInsets !== void 0 ? _useSafeAreaInsets : _state.useSafeAreaInsets = hooks.useSafeAreaInsets;
  (_useSafeAreaFrame = (_state1 = state).useSafeAreaFrame) !== null && _useSafeAreaFrame !== void 0 ? _useSafeAreaFrame : _state1.useSafeAreaFrame = hooks.useSafeAreaFrame;
  if (!metrics || previous && sameMetrics(previous, metrics)) return;
  state.initialMetrics = metrics;
  (_g___tamagui_safe_area_subscriptions__ = g.__tamagui_safe_area_subscriptions__) === null || _g___tamagui_safe_area_subscriptions__ === void 0 ? void 0 : _g___tamagui_safe_area_subscriptions__.listeners.forEach(function(listener) {
    return listener();
  });
}
function sameMetrics(a, b) {
  return a.insets.top === b.insets.top && a.insets.right === b.insets.right && a.insets.bottom === b.insets.bottom && a.insets.left === b.insets.left && a.frame.x === b.frame.x && a.frame.y === b.frame.y && a.frame.width === b.frame.width && a.frame.height === b.frame.height;
}
//# sourceMappingURL=tamaguiSafeArea.native.js.map
